import { OptionsModel } from '@d-components/form/form.interface';
import { ApplicationApprovalStatus } from '@d-models/services/application.model';
import { RecipientApprovalStatus } from '@d-models/services/recipient.model';

export enum Routers {
  DASHBOARD = 'dashboard',
  LOGIN = 'login',
}

export enum Storage {
  JWT = 'access_token',
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
}

export enum ModalSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA = 'extra',
  SUPER_EXTRA = 'super-extra',
}

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warn',
}

export enum ToastSummary {
  SUCCESS = 'Success!',
  ERROR = 'Error!',
  INFO = 'Info!',
  WARNING = 'Warning!',
}

export enum SystemStatusEnum {
  DRAFT = 0,
  PENDING = 1,
  APPROVED = 2,
  ACTIVE = 3,
  INACTIVE = 4,
  REJECTED = 5,
}

export enum EntityStatusEnum {
  INACTIVE = 0,
  ACTIVE = 1,
  NEW = 2,
}

export enum UserStatusEnum {
  DISABLED = 0,
  ENABLED = 1,
}

export enum RoleStatusEnum {
  DISABLED = -1,
  ENABLED = 1,
}

export enum UserGroupStatusEnum {
  DISABLED = -1,
  ENABLED = 1,
}
export enum ApprovedFlowStatusEnum {
  DRAFT = 0,
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum UnApprovedFlowStatusEnum {
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum MerchantStatusEnum {
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum ManageModal {
  VIEW = 0,
  UPDATE = 1,
}

export enum ProductNameUnit {
  KG = 1,
  LITRE = 2,
  PCS = 3,
  QTY = 4,
}

export enum AssetApplication {
  ONLINE = 1,
  OFFLINE = 0,
}

export enum TransactionModeEnum {
  MANUAL = 0,
  MYKAD = 1,
  OFFLINE = 2,
  SMART_CARD = 3,
  SYSTEM = 4,
}

export enum TransactionTypeEnum {
  ALLOCATION = 1,
  REVERSAL = 2,
  SALES = 3,
  ADJUSTMENT_TOPUP = 4,
  VOID = 5,
  ADJUSTMENT_WITHDRAWAL = 6,
}

export enum TransactionStatusEnum {
  FAILED = 0,
  SUCCESS = 1,
}

export const ProductUnit: OptionsModel[] = [
  {
    label: 'Kg',
    value: ProductNameUnit.KG,
  },
  {
    label: 'Pcs',
    value: ProductNameUnit.PCS,
  },
  {
    label: 'Litre',
    value: ProductNameUnit.LITRE,
  },
];

export const InhouseProduct: OptionsModel[] = [
  {
    label: 'Giant',
    value: '1',
  },
  {
    label: 'Lotus',
    value: '2',
  },
  {
    label: 'Ramadhan',
    value: '3',
  },
  {
    label: 'BPEN',
    value: '4',
  },
  {
    label: 'ECONSAVE',
    value: '5',
  },
];

export const AcknowledgementStatus: OptionsModel[] = [
  {
    label: 'PENDING',
    value: 0,
  },
  {
    label: 'AUTHORIZED',
    value: 1,
  },
  {
    label: 'REJECTED',
    value: 2,
  },
];

export const ApprovedFlowStatus: OptionsModel[] = [
  {
    label: 'DRAFT',
    value: ApprovedFlowStatusEnum.DRAFT,
  },
  {
    label: 'PENDING',
    value: ApprovedFlowStatusEnum.PENDING,
  },
  {
    label: 'APPROVED',
    value: ApprovedFlowStatusEnum.APPROVED,
  },
  {
    label: 'REJECTED',
    value: ApprovedFlowStatusEnum.REJECTED,
  },
];

export const UnApprovedFlowStatus: OptionsModel[] = [
  {
    label: 'ACTIVE',
    value: UnApprovedFlowStatusEnum.ACTIVE,
  },
  {
    label: 'INACTIVE',
    value: UnApprovedFlowStatusEnum.INACTIVE,
  },
];

export const SystemStatus: OptionsModel[] = [
  {
    label: 'DRAFT',
    value: SystemStatusEnum.DRAFT,
  },
  {
    label: 'PENDING',
    value: SystemStatusEnum.PENDING,
  },
  {
    label: 'APPROVED',
    value: SystemStatusEnum.APPROVED,
  },
  {
    label: 'ACTIVE',
    value: SystemStatusEnum.ACTIVE,
  },
  {
    label: 'INACTIVE',
    value: SystemStatusEnum.INACTIVE,
  },
  {
    label: 'REJECTED',
    value: SystemStatusEnum.REJECTED,
  },
];

export enum ASSET_STATUS_ENUM {
  ACTIVE = 0,
  DISPOSED_EOL = 1,
  DISPOSED_LOST = 2,
  DRAFT = 3,
  IN_REPAIR = 4,
  IN_TRANSIT = 5,
  PICK_UP = 6,
  PRE_SORTING = 7,
  UNASSIGNED = 8,
  ASSIGNED = 9,
}

export const AssetStatus: OptionsModel[] = [
  {
    label: 'ACTIVE',
    value: ASSET_STATUS_ENUM.ACTIVE,
  },
  {
    label: 'DISPOSED_EOL',
    value: ASSET_STATUS_ENUM.DISPOSED_EOL,
  },
  {
    label: 'DISPOSED_LOST',
    value: ASSET_STATUS_ENUM.DISPOSED_LOST,
  },
  {
    label: 'DRAFT',
    value: ASSET_STATUS_ENUM.DRAFT,
  },
  {
    label: 'IN_REPAIR',
    value: ASSET_STATUS_ENUM.IN_REPAIR,
  },
  {
    label: 'IN_TRANSIT',
    value: ASSET_STATUS_ENUM.IN_TRANSIT,
  },
  {
    label: 'PICK_UP',
    value: ASSET_STATUS_ENUM.PICK_UP,
  },
  {
    label: 'PRE_SORTING',
    value: ASSET_STATUS_ENUM.PRE_SORTING,
  },
  {
    label: 'UNASSIGNED',
    value: ASSET_STATUS_ENUM.UNASSIGNED,
  },
  {
    label: 'ASSIGNED',
    value: ASSET_STATUS_ENUM.ASSIGNED,
  },
];

export const EntityStatus: OptionsModel[] = [
  {
    label: 'INACTIVE',
    value: EntityStatusEnum.INACTIVE,
  },
  {
    label: 'ACTIVE',
    value: EntityStatusEnum.ACTIVE,
  },
  {
    label: 'NEW',
    value: EntityStatusEnum.NEW,
  },
];

export const UserStatusOptions: OptionsModel[] = [
  {
    label: 'DISABLED',
    value: UserStatusEnum.DISABLED,
  },
  {
    label: 'ENABLED',
    value: UserStatusEnum.ENABLED,
  },
];

export const RoleStatusOptions: OptionsModel[] = [
  {
    label: 'DISABLED',
    value: RoleStatusEnum.DISABLED,
  },
  {
    label: 'ENABLED',
    value: RoleStatusEnum.ENABLED,
  },
];

export const UserGroupStatusOptions: OptionsModel[] = [
  {
    label: 'DISABLED',
    value: UserGroupStatusEnum.DISABLED,
  },
  {
    label: 'ENABLED',
    value: UserGroupStatusEnum.ENABLED,
  },
];

export const DEFAULT_FORMAT_DATE = 'DD/MM/YYYY';
export const DEFAULT_FORMAT_DATETIME = 'DD/MM/YYYY HH:mm:ss';
export const DATE_HOUR_MINUTES_UPPER_MERIDIEM = 'DD/MM/YYYY hh:mm A';
export const DATE_HOUR_MINUTES_SECONDS_UPPER_MERIDIEM = 'DD/MM/YYYY hh:mm:ss A';

export enum FILTER_ORDER {
  ASC = 1,
  DESC = -1,
}

// export const BUTTON_APPROVE = 'Approve';
// export const BUTTON_REJECT = 'Reject';

export const enum BUTTON_NAMES {
  APPROVE = 'Approve',
  REJECT = 'Reject',
  SUSPEND = 'Suspend',
  TERMINATE = 'Terminate',
  GRADUATE = 'Graduate',
  UPDATE_ALLOCATIOn = 'Update Allocation',
}

export const ENTITY_STATUS_COLOR = {
  ACTIVE: {
    statusLabel: 'ACTIVE',
    contentColor: 'bg-green-500',
  },
  INACTIVE: {
    statusLabel: 'INACTIVE',
    contentColor: 'bg-red-500',
  },
  NEW: {
    statusLabel: 'NEW',
    contentColor: 'bg-yellow-500',
  },
};

export const APPROVAL_STATUS_COLOR = {
  APPROVED: {
    statusLabel: 'APPROVED',
    contentColor: 'bg-green-500',
  },
  REJECTED: {
    statusLabel: 'REJECTED',
    contentColor: 'bg-red-500',
  },
  PENDING: {
    statusLabel: 'PENDING',
    contentColor: 'bg-yellow-500',
  },
  DRAFT: {
    statusLabel: 'DRAFT',
    contentColor: 'bg-gray-500',
  },
};

export enum VIEW_MODE {
  CREATE = 'create',
  VIEW = 'view',
  MANAGE = 'manage',
  EDIT = 'edit',
}

export const ASSET_APPLICATION: OptionsModel[] = [
  {
    label: 'ONLINE',
    value: AssetApplication.ONLINE,
  },
  {
    label: 'OFFLINE',
    value: AssetApplication.OFFLINE,
  },
];

export enum CoreAPIErrorCode {
  DuplicateEmailFound = 415,
}
export const Gender: OptionsModel[] = [
  {
    label: 'MALE',
    value: 0,
  },
  {
    label: 'FEMALE',
    value: 1,
  },
];

export const AddressType: OptionsModel[] = [
  {
    label: 'MAILING',
    value: 0,
  },
  {
    label: 'PERMANENT',
    value: 1,
  },
  {
    label: 'EMPLOYER',
    value: 2,
  },
];

export const IdentityType: OptionsModel[] = [
  {
    label: 'MYKAD',
    value: 0,
  },
  {
    label: 'PASSPORT',
    value: 1,
  },
  {
    label: 'REFUGEE',
    value: 2,
  },
];

export const Race: OptionsModel[] = [];

export enum ApplicationTab {
  PROFILE = 'profile',
  ALLOCATION = 'allocation',
  WALLET = 'wallet',
  MERCHANT_LINK = 'merchant-link',
  ENTITLEMENT = 'entitlement',
  CARD = 'card',
  ACTIVITIES = 'activities',
  CUSTOM_DATA = 'custom-data',
}

export enum BatchTab {
  BATCH_DETAILS = 'batch-detail',
  APPLICATIONS = 'application',
  MERCHANT_LINK = 'merchant-link',
  ALLOCATION = 'allocation',
}

export enum ApplicationStatus {
  DRAFT = 0,
  PENDING = 1,
  REGISTERED = 2,
  NOMINATED = 3,
  PENDING_ALLOCATION_SETUP = 4,
  PENDING_ALLOCATION_REVIEW = 5,
  PENDING_ALLOCATION_APPROVAL = 6,
  APPROVED_AND_PENDING_ACTIVATION = 7,
  ACTIVATED = 8,
  SUSPENDED = 9,
  TERMINATED = 10,
  GRADUATED = 11,
  KIV = 12,
}

export const ApplicationAction = {
  SUBMIT: {
    label: 'SUBMIT',
    value: 'Submit',
  },
  KIV: {
    label: 'KIV',
    value: 'KIV',
  },
  APPROVE: {
    label: 'APPROVE',
    value: 'Approve',
  },
  REJECT: {
    label: 'REJECT',
    value: 'Reject',
  },
  TERMINATE: {
    label: 'TERMINATE',
    value: 'Terminate',
  },
  SUSPEND: {
    label: 'SUSPEND',
    value: 'Suspend',
  },
  GRADUATE: {
    label: 'GRADUATE',
    value: 'Graduate',
  },
  REINSTATE: {
    label: 'REINSTATE',
    value: 'Reinstate',
  },
  RECONSIDER: {
    label: 'RECONSIDER',
    value: 'Reconsider',
  },
  REALLOCATION: {
    label: 'REALLOCATION',
    value: 'Update Allocation',
  },
};

export const ApplicationBatchProcessStatus = [
  {
    label: 'PROCESSING',
    value: 0,
  },
  {
    label: 'COMPLETED',
    value: 1,
  },
  {
    label: 'FAILED',
    value: 2,
  },
];

export const BatchApplicationStatusConstant: {
  label: string;
  value: number | null;
  dtoField: keyof ApplicationApprovalStatus;
  approvalStatus: string;
}[] = [
  {
    label: 'ALL',
    value: null,
    dtoField: 'all',
    approvalStatus: '',
  },
  {
    label: 'DRAFT',
    value: ApplicationStatus.DRAFT,
    dtoField: 'draft',
    approvalStatus: 'Draft',
  },
  {
    label: 'REGISTERED',
    value: ApplicationStatus.REGISTERED,
    dtoField: 'registered',
    approvalStatus: 'Registered',
  },

  {
    label: 'PENDING_ALLOCATION_SETUP',
    value: ApplicationStatus.PENDING_ALLOCATION_SETUP,
    dtoField: 'pendingAllocationSetup',
    approvalStatus: 'Pending Allocation Setup',
  },
  {
    label: 'PENDING_ALLOCATION_REVIEW',
    value: ApplicationStatus.PENDING_ALLOCATION_REVIEW,
    dtoField: 'pendingAllocationReview',
    approvalStatus: 'Pending Allocation Review',
  },
  {
    label: 'PENDING_ALLOCATION_APPROVAL',
    value: ApplicationStatus.PENDING_ALLOCATION_APPROVAL,
    dtoField: 'pendingAllocationApproval',
    approvalStatus: 'Pending Allocation Approval',
  },
  {
    label: 'ACTIVATED',
    value: ApplicationStatus.ACTIVATED,
    dtoField: 'activated',
    approvalStatus: 'Activated',
  },
  {
    label: 'SUSPENDED',
    value: ApplicationStatus.SUSPENDED,
    dtoField: 'suspended',
    approvalStatus: 'Suspended',
  },
  {
    label: 'TERMINATED',
    value: ApplicationStatus.TERMINATED,
    dtoField: 'terminated',
    approvalStatus: 'Terminated',
  },
  {
    label: 'GRADUATED',
    value: ApplicationStatus.GRADUATED,
    dtoField: 'graduated',
    approvalStatus: 'Graduated',
  },
  {
    label: 'KIV',
    value: ApplicationStatus.KIV,
    dtoField: 'kiv',
    approvalStatus: 'KIV',
  },
];

export const ApplicationApprovalFlowStatusConstant: {
  label: string;
  value: number | null;
  dtoField: keyof ApplicationApprovalStatus;
  approvalStatus: string;
}[] = [
  {
    label: 'ALL',
    value: null,
    dtoField: 'all',
    approvalStatus: '',
  },
  {
    label: 'DRAFT',
    value: ApplicationStatus.DRAFT,
    dtoField: 'draft',
    approvalStatus: 'Draft',
  },
  {
    label: 'PENDING',
    value: ApplicationStatus.PENDING,
    dtoField: 'pending',
    approvalStatus: 'Pending',
  },
  {
    label: 'REGISTERED',
    value: ApplicationStatus.REGISTERED,
    dtoField: 'registered',
    approvalStatus: 'Registered',
  },
  {
    label: 'NOMINATED',
    value: ApplicationStatus.NOMINATED,
    dtoField: 'nominated',
    approvalStatus: 'Nominated',
  },
  {
    label: 'PENDING_ALLOCATION_SETUP',
    value: ApplicationStatus.PENDING_ALLOCATION_SETUP,
    dtoField: 'pendingAllocationSetup',
    approvalStatus: 'Pending Allocation Setup',
  },
  {
    label: 'PENDING_ALLOCATION_REVIEW',
    value: ApplicationStatus.PENDING_ALLOCATION_REVIEW,
    dtoField: 'pendingAllocationReview',
    approvalStatus: 'Pending Allocation Review',
  },
  {
    label: 'PENDING_ALLOCATION_APPROVAL',
    value: ApplicationStatus.PENDING_ALLOCATION_APPROVAL,
    dtoField: 'pendingAllocationApproval',
    approvalStatus: 'Pending Allocation Approval',
  },
  {
    label: 'APPROVED_AND_PENDING_ACTIVATION',
    value: ApplicationStatus.APPROVED_AND_PENDING_ACTIVATION,
    dtoField: 'approvedAndPendingActivation',
    approvalStatus: 'Approved and Pending for Activation',
  },
  {
    label: 'ACTIVATED',
    value: ApplicationStatus.ACTIVATED,
    dtoField: 'activated',
    approvalStatus: 'Activated',
  },
  {
    label: 'SUSPENDED',
    value: ApplicationStatus.SUSPENDED,
    dtoField: 'suspended',
    approvalStatus: 'Suspended',
  },
  {
    label: 'TERMINATED',
    value: ApplicationStatus.TERMINATED,
    dtoField: 'terminated',
    approvalStatus: 'Terminated',
  },
  {
    label: 'GRADUATED',
    value: ApplicationStatus.GRADUATED,
    dtoField: 'graduated',
    approvalStatus: 'Graduated',
  },
  {
    label: 'KIV',
    value: ApplicationStatus.KIV,
    dtoField: 'kiv',
    approvalStatus: 'KIV',
  },
];

export enum cardListingStatus {
  ALL = 0,
  ACTIVE = 1,
  BLOCKED = 2,
  TERMINATED = 3,
}

export const CardListingStatusOption: OptionsModel[] = [
  { label: 'ALL', value: 0 },
  { label: 'ACTIVE', value: 1 },
  { label: 'BLOCKED', value: 2 },
  { label: 'TERMINATED', value: 3 },
];

export enum MerchantType {
  SINGLE = 0,
  CHAIN = 1,
}

export const MerchantTypeOptions: OptionsModel[] = [
  { label: 'CHAIN', value: 1 },
  { label: 'SINGLE', value: 0 },
];

export enum ActionStatusMerchantBranchEnum {
  PROCESSING = 1,
  KIV = 2,
  REJECTED = 3,
  ACTION_REQUIRED = 4,
}

export const ACTION_STATUS_MERCHANT_BRANCH = [
  {
    label: 'Processing',
    value: ActionStatusMerchantBranchEnum.PROCESSING,
  },
  {
    label: 'KIV',
    value: ActionStatusMerchantBranchEnum.KIV,
  },
  {
    label: 'Action Required',
    value: ActionStatusMerchantBranchEnum.ACTION_REQUIRED,
  },
  {
    label: 'Rejected',
    value: ActionStatusMerchantBranchEnum.REJECTED,
  },
];

export enum ApprovalStatusMerchantBranchEnum {
  PROCESSING = 1,
  RETURN = 2,
  ON_HOLD = 3,
  INITIAL_REJECT = 4,
}

export const APPROVAL_STATUS_MERCHANT_BRANCH = [
  {
    label: 'Processing',
    value: ApprovalStatusMerchantBranchEnum.PROCESSING,
  },
  {
    label: 'Return',
    value: ApprovalStatusMerchantBranchEnum.RETURN,
  },
  {
    label: 'On Hold',
    value: ApprovalStatusMerchantBranchEnum.ON_HOLD,
  },
  {
    label: 'Initial Reject',
    value: ApprovalStatusMerchantBranchEnum.INITIAL_REJECT,
  },
];

export enum MerchantApplicationApprovalStatus {
  DRAFT = 0, //can delete
  PROCESSING = 1,
  ACTION_REQUIRED = 2, //can edit
  ON_HOLD = 3,
  INITIAL_REJECT = 4,
  PENDING_KYC = 5,
  PENDING_1ST_LEVEL_KYC_APPROVAL = 6,
  PENDING_2ND_LEVEL_KYC_APPROVAL = 7,
  PENDING_FINAL_APPROVAL = 8,
  PENDING_MERCHANT_AUTHORIZATION = 9,
  AUTHORIZED = 10,
}

export const MERCHANT_APPLICATION_APPROVAL_FLOW_STATUS_FOR_GET_BUTTONS: OptionsModel[] =
  [
    {
      label: 'Draft',
      value: MerchantApplicationApprovalStatus.DRAFT,
    },
    {
      label: 'Processing',
      value: MerchantApplicationApprovalStatus.PROCESSING,
    },
    {
      label: 'Action Required',
      value: MerchantApplicationApprovalStatus.ACTION_REQUIRED,
    },
    {
      label: 'On Hold',
      value: MerchantApplicationApprovalStatus.ON_HOLD,
    },
    {
      label: 'Initial Reject',
      value: MerchantApplicationApprovalStatus.INITIAL_REJECT,
    },
    {
      label: 'Pending KYC',
      value: MerchantApplicationApprovalStatus.PENDING_KYC,
    },
    {
      label: 'Pending 1st level KYC Approval',
      value: MerchantApplicationApprovalStatus.PENDING_1ST_LEVEL_KYC_APPROVAL,
    },
    {
      label: 'Pending 2nd level KYC Approval',
      value: MerchantApplicationApprovalStatus.PENDING_2ND_LEVEL_KYC_APPROVAL,
    },
    {
      label: 'Pending Final Approval',
      value: MerchantApplicationApprovalStatus.PENDING_FINAL_APPROVAL,
    },
    {
      label: 'Pending Merchant Authorization',
      value: MerchantApplicationApprovalStatus.PENDING_MERCHANT_AUTHORIZATION,
    },
  ];

export const MERCHANT_APPLICATION_APPROVAL_STATUS: OptionsModel[] = [
  {
    label: 'DRAFT',
    value: MerchantApplicationApprovalStatus.DRAFT,
  },
  { label: 'PROCESSING', value: MerchantApplicationApprovalStatus.PROCESSING },
  {
    label: 'ACTION_REQUIRED',
    value: MerchantApplicationApprovalStatus.ACTION_REQUIRED,
  },
  { label: 'ON_HOLD', value: MerchantApplicationApprovalStatus.ON_HOLD },
  {
    label: 'INITIAL_REJECT',
    value: MerchantApplicationApprovalStatus.INITIAL_REJECT,
  },
  {
    label: 'PENDING_KYC',
    value: MerchantApplicationApprovalStatus.PENDING_KYC,
  },
  {
    label: 'PENDING_1ST_LEVEL_KYC_APPROVAL',
    value: MerchantApplicationApprovalStatus.PENDING_1ST_LEVEL_KYC_APPROVAL,
  },
  {
    label: 'PENDING_2ND_LEVEL_KYC_APPROVAL',
    value: MerchantApplicationApprovalStatus.PENDING_2ND_LEVEL_KYC_APPROVAL,
  },
  {
    label: 'PENDING_FINAL_APPROVAL',
    value: MerchantApplicationApprovalStatus.PENDING_FINAL_APPROVAL,
  },
  {
    label: 'PENDING_MERCHANT_AUTHORIZATION',
    value: MerchantApplicationApprovalStatus.PENDING_MERCHANT_AUTHORIZATION,
  },
  { label: 'AUTHORIZED', value: MerchantApplicationApprovalStatus.AUTHORIZED },
];

export enum MerchantApplicationStatus {
  DRAFT = 0,
  PROCESSING = 1,
  KIV = 2,
  REJECTED = 3,
  RETURN = 4,
  PENDING_KYC = 5,
  PENDING_1ST_LEVEL_KYC_APPROVAL = 6,
  PENDING_2ND_LEVEL_KYC_APPROVAL = 7,
  PENDING_FINAL_APPROVAL = 8,
  PENDING_MERCHANT_AUTHORIZATION = 9,
  AUTHORIZED = 10,
}

export enum MerchantStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}

export enum ProgrammeInvolvedType {
  ALL = 0,
  SPECIFIC = 1,
}

export const PROGRAMME_INVOLVED_TYPE: OptionsModel[] = [
  {
    label: 'ALL_PROGRAMMES',
    value: ProgrammeInvolvedType.ALL,
  },
  {
    label: 'SPECIFIC_PROGRAMME',
    value: ProgrammeInvolvedType.SPECIFIC,
  },
];

export const MERCHANT_STATUS: OptionsModel[] = [
  {
    label: 'ACTIVE',
    value: MerchantStatus.ACTIVE,
  },
  {
    label: 'INACTIVE',
    value: MerchantStatus.INACTIVE,
  },
];

export const ERP_SYNC_STATUS: OptionsModel[] = [
  { label: 'PENDING', value: 0 },
  { label: 'PENDING_ERP_RESPONSE', value: 1 },
  { label: 'FAILED', value: 2 },
  { label: 'SUCCESS', value: 3 },
];

export const MERCHANT_TYPES: OptionsModel[] = [
  {
    label: 'Headquarter',
    value: 'MERCHANT_COMPANY_PROFILE_TYPE_HEADQUARTER',
  },
  {
    label: 'Subsidiary',
    value: 'MERCHANT_COMPANY_PROFILE_TYPE_SUBSIDIARY',
  },
  {
    label: 'Outlet',
    value: 'MERCHANT_COMPANY_PROFILE_TYPE_OUTLET',
  },
];

export const MERCHANT_APPLICATION_STATUS: OptionsModel[] = [
  {
    label: 'Draft',
    value: MerchantApplicationStatus.DRAFT,
  },
  {
    label: 'Processing',
    value: MerchantApplicationStatus.PROCESSING,
  },
  {
    label: 'KIV',
    value: MerchantApplicationStatus.KIV,
  },
  {
    label: 'Rejected',
    value: MerchantApplicationStatus.REJECTED,
  },
  {
    label: 'Return',
    value: MerchantApplicationStatus.RETURN,
  },
  {
    label: 'Pending KYC',
    value: MerchantApplicationStatus.PENDING_KYC,
  },
  {
    label: 'Pending 1st level KYC Approval',
    value: MerchantApplicationStatus.PENDING_1ST_LEVEL_KYC_APPROVAL,
  },
  {
    label: 'Pending 2nd level KYC Approval',
    value: MerchantApplicationStatus.PENDING_2ND_LEVEL_KYC_APPROVAL,
  },
  {
    label: 'Pending Final Approval',
    value: MerchantApplicationStatus.PENDING_FINAL_APPROVAL,
  },
  {
    label: 'Pending Merchant Authorization',
    value: MerchantApplicationStatus.PENDING_MERCHANT_AUTHORIZATION,
  },
  {
    label: 'Authorized',
    value: MerchantApplicationStatus.AUTHORIZED,
  },
];

export enum MerchantApplicationApprovalButtonNameEnum {
  ON_HOLD = 'On Hold',
  RETURN = 'Return',
  REJECT = 'Reject',
  APPROVE = 'Approve',
  SUBMIT = 'Submit',
  ACCEPT = 'Accept',
  REACTIVATE = 'Reactivate',
}

export enum MerchantAddressTypeConstant {
  REGISTERED_ADDRESS = 0,
  BUSINESS_OPERATION_ADDRESS = 1,
  TAX_REGISTERED_BUSINESS_ADDRESS = 2,
}

export enum MerchantApplicationSupportDocumentType {
  LEGAL_DOCUMENT = 0,
  SSM_COMPANY_PROFILE = 1,
  OPERATING_LICENSE = 2,
  SST_APPROVAL_LETTER = 3,
  LATEST_BANK_STATEMENT = 4,
  PHOTOCOPY_OF_IDENTITY_CARD = 5,
  OTHERS = 6,
}

export enum BankNameEnum {
  AMBANK = 1,
  PUBLIC_BANK_FILE = 2,
}

export const BankNameOptions: OptionsModel[] = [
  {
    label: 'Ambank',
    value: BankNameEnum.AMBANK,
  },
  {
    label: 'Public Bank File',
    value: BankNameEnum.PUBLIC_BANK_FILE,
  },
];

export enum MerchantApplicationBusinessProfileAttachmentType {
  STORE_PHOTO = 0,
  PRODUCT_LIST = 1,
}

export enum RecipientCardStatusConstant {
  ACTIVE = 1,
  BLOCKED = 2,
}

export const MerchantApplicationSupportDocumentTypeLabelMapper = {
  [MerchantApplicationSupportDocumentType.PHOTOCOPY_OF_IDENTITY_CARD]:
    'PHOTO_OF_ID_CARD',
  [MerchantApplicationSupportDocumentType.LATEST_BANK_STATEMENT]:
    'LATEST_BANK_STATEMENT',
  [MerchantApplicationSupportDocumentType.LEGAL_DOCUMENT]:
    'LEGAL_DOCUMENT_ON_FORMATION',
  [MerchantApplicationSupportDocumentType.SSM_COMPANY_PROFILE]:
    'SSM_COMPANY_PROFILE',
  [MerchantApplicationSupportDocumentType.OPERATING_LICENSE]:
    'OPERATING_LICENSE',
  [MerchantApplicationSupportDocumentType.SST_APPROVAL_LETTER]:
    'TAX_APPROVAL_LETTER',
  [MerchantApplicationSupportDocumentType.OTHERS]: 'OTHERS',
};

export const MerchantApplicationBusinessProfileAttachmentTypeLabelMapper = {
  [MerchantApplicationBusinessProfileAttachmentType.PRODUCT_LIST]:
    'PRODUCT_LIST',
  [MerchantApplicationBusinessProfileAttachmentType.STORE_PHOTO]: 'STORE_PHOTO',
};

export const DAYS_OF_WEEK = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const MAX_INT_32 = 2147483647;

export enum TENANT_SETTING_CONSTANT {
  CURRENCY = 'CURRENCY',
  PO_ERP_FAILED = 'PO-ERP-FAILED',
  MERCHANT_ERP_FAILED = 'MERCHANT-ERP-FAILED',
  MERCHANT_SUSPENSION = 'MERCHANT-SUSPENSION',
  DWO_SWO_SUBMITTED = 'DWO-SWO-SUBMITTED',
  DWO_SWO_COMPLETION = 'DWO-SWO-COMPLETION',
  DWO_SWO_CANCELLATION = 'DWO-SWO-CANCELLATION',
}

export enum PO_SETTING_CONSTANT {
  CARD_NEW_SUBMISSION = 'CARD-NEW-SUBMISSION',
  CARD_LOST_SUBMISSION = 'CARD-LOST-SUBMISSION',
  CARD_BLOCK_SUBMISSION = 'CARD-BLOCK-SUBMISSION',
  CARD_LOST_APPROVAL = 'CARD-LOST-APPROVAL',
  CARD_BLOCK_APPROVAL = 'CARD-BLOCK-APPROVAL',
  CARD_LOST_REJECTION = 'CARD-LOST-REJECTION',
  CARD_BLOCK_REJECTION = 'CARD-BLOCK-REJECTION',
  RECIPIENT_APPLICATION = 'RECIPIENT-END-NOTICE-PERIOD-PROGRAM',
}

export const IdentityTypes: OptionsModel[] = [
  { label: 'MYKAD', value: 0 },
  { label: 'PASSPORT', value: 1 },
  { label: 'REFUGEE', value: 2 },
];

export const IdentityCategories: OptionsModel[] = [
  { label: 'MYKAD', value: 0 },
  { label: 'SMART_CARD', value: 1 },
  { label: 'WHALET_CARD', value: 2 },
];

export enum InvoicingStatusEnum {
  NEW = 0,
  FILE_CREATED = 1,
  POSTED = 2,
  PAID = 3,
  FAILED = 4,
}

export enum SettlementStatusEnum {
  DISABLED = 0,
  ENABLED = 1,
}

export const SettlementStatusOptions: OptionsModel[] = [
  { label: 'DISABLED', value: SettlementStatusEnum.DISABLED },
  { label: 'ENABLED', value: SettlementStatusEnum.ENABLED },
];

export const AccountType: OptionsModel[] = [
  { label: 'SUPPLEMENT_ACCOUNT', value: 0 },
  { label: 'MAIN_ACCOUNT', value: 1 },
];

export const TransactionTypeOptions: OptionsModel[] = [
  {
    label: 'TOPUP',
    value: TransactionTypeEnum.ADJUSTMENT_TOPUP,
  },
  {
    label: 'WITHDRAWAL',
    value: TransactionTypeEnum.ADJUSTMENT_WITHDRAWAL,
  },
];

export enum SettlementFrequencyEnum {
  OneTime = 0,
  Daily = 1,
  Weekly = 2,
  BiWeekly = 3,
  BiMonthly = 4,
  Monthly = 5,
  Custom = 6,
}

export const SettlementFrequencyOptions: OptionsModel[] = [
  {
    label: 'ONE_TIME',
    value: SettlementFrequencyEnum.OneTime,
  },
  {
    label: 'DAILY',
    value: SettlementFrequencyEnum.Daily,
  },
  {
    label: 'WEEKLY',
    value: SettlementFrequencyEnum.Weekly,
  },
  {
    label: 'BI_WEEKLY',
    value: SettlementFrequencyEnum.BiWeekly,
  },
  {
    label: 'BI_MONTHLY',
    value: SettlementFrequencyEnum.BiMonthly,
  },
  {
    label: 'MONTHLY',
    value: SettlementFrequencyEnum.Monthly,
  },
  {
    label: 'CUSTOM',
    value: SettlementFrequencyEnum.Custom,
  },
];

export const SettlementCalculateOptions: OptionsModel[] = [
  { label: 'INCLUSIVE', value: false },
  { label: 'EXCLUSIVE', value: true },
];

export enum SettlementInvoiceTypeEnum {
  ASNAF = 0,
  COMMUNITY = 1,
  PROGRAMME = 2,
  DISTRICT = 3,
  STATE = 4,
}

export const SettlementInvoiceTypeOptions: OptionsModel[] = [
  { label: 'ASNAF', value: 0 },
  { label: 'COMMUNITY', value: 1 },
  { label: 'PROGRAMME', value: 2 },
  { label: 'DISTRICT', value: 3 },
  { label: 'STATE', value: 4 },
];

export const YesNoOptions: OptionsModel[] = [
  {
    label: 'YES',
    value: true,
  },
  {
    label: 'NO',
    value: false,
  },
];

export const ProductUnitOptions: OptionsModel[] = [
  {
    label: 'Kg',
    value: ProductNameUnit.KG,
  },
  {
    label: 'Pcs',
    value: ProductNameUnit.PCS,
  },
  {
    label: 'L',
    value: ProductNameUnit.LITRE,
  },
  {
    label: 'Qty',
    value: ProductNameUnit.QTY,
  },
];

export const CardTypes: OptionsModel[] = [
  { label: 'IDENTITY_CARD', value: 0 },
  { label: 'SMART_CARD', value: 1 },
];

export const PaymentModes: OptionsModel[] = [
  { label: 'ONLINE', value: true },
  { label: 'OFFLINE', value: false },
];

export const LimitManualEntries: OptionsModel[] = [
  { label: 'RECIPIENT', value: 0 },
  { label: 'MERCHANT_CARD', value: 1 },
  { label: 'UNLIMITED', value: 2 },
];

export const WeekDays: OptionsModel[] = [
  { label: 'SUNDAY', value: 0 },
  { label: 'MONDAY', value: 1 },
  { label: 'TUESDAY', value: 2 },
  { label: 'WEDNESDAY', value: 3 },
  { label: 'THURSDAY', value: 4 },
  { label: 'FRIDAY', value: 5 },
  { label: 'SATURDAY', value: 6 },
];

export enum ProductRuleValidationUnderList {
  PRODUCT_CATEGORY = 1,
  PRODUCT_NAME = 3,
  PRODUCT_GROUP = 2,
}

export const MerchantTerminalSettingOptions = [
  {
    label: 'DISABLED',
    value: false,
  },
  {
    label: 'ENABLED',
    value: true,
  },
];

export enum ManagePINActionType {
  CREATE = 1,
  CHANGE_FROM_TERMINAL = 2,
  GENERATE_FROM_PORTAL = 3,
}

export const ManagePINActionTypeOptions: OptionsModel[] = [
  { label: 'CREATE', value: ManagePINActionType.CREATE },
  {
    label: 'CHANGE_FROM_TERMINAL',
    value: ManagePINActionType.CHANGE_FROM_TERMINAL,
  },
  {
    label: 'GENERATE_FROM_PORTAL',
    value: ManagePINActionType.GENERATE_FROM_PORTAL,
  },
];
